import gql from 'graphql-tag';

const queryGetEmotionalTriggersTable = gql`
  query getEmotionalTriggersTable($id: Int!, $thematicSelectionId: Int) {
    getEmotionalTriggersTable(id: $id, thematicSelectionId: $thematicSelectionId) {
      id
      title
      description
      isDefault
      createdBy {
        email
        firstName
        lastName
      }
      settings {
        analysisAxis
        itemsToDisplay {
          name
          key
        }
        calculationCriteria
        significanceThreshold
        range {
          startDate
          endDate
        }
        thematics {
          thematic
          subThematic
          subSubThematic
          joinSpecify
        }
        criteriaKeys {
          name
          values
        }
      }
      customizations {
        originalName
        name
        originalColor
        color
        items {
          originalName
          name
        }
        deleted
        masked
      }
      data {
        originalName
        name
        originalColor
        color
        items {
          originalName
          name
          percentage
          value
          impactSat
          differentielSat
        }
        value
        deleted
        masked
      }
    }
  }
`;

export default queryGetEmotionalTriggersTable;
